import { isMobile, isMobileOnly } from 'react-device-detect';
import { formURL } from '@wsc/utils/apiUtils';

export const getLocalizedPath = (localeCode, sceneName) => {
	let prefix = '';
	if (localeCode) {
		prefix = `/${localeCode}`;
	}
	return `${prefix}/${sceneName}`;
};

const formatDate = (date, format) => {
	const map = {
		mm: date.getMonth() + 1,
		dd: date.getDate(),
		yy: date.getFullYear().toString().slice(-2),
		hh: date.getHours().toString(),
		yyyy: date.getFullYear(),
	};

	return format.replace(/mm|dd|hh|yy|yyy/gi, (matched) => map[matched]);
};

export const getBustKey = (sceneJson) => {
	if (
		sceneJson?.image_integrity ||
		sceneJson?.environment_map_config?.url?.image_integrity
	) {
		return sceneJson.image_integrity.replace(/\D/g, '');
	}
	return formatDate(new Date(), 'hhmmddyyyy');
};

/**
 *
 * @param {String} param search param to check the url for
 * @returns {String | false}
 */
export const checkIfURLContainsSearchParam = (param) => {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(param, false);
};

export const replaceParamValue = (param, newval) => {
	let str = window.location.search;
	if (!newval) return;
	var regex = new RegExp('([?;&])' + param + '[^&#;]*[;&]?');
	var query = str.replace(regex, '$1').replace(/&$/, '');

	str =
		(query.length > 2 ? query + '&' : '?') +
		(newval ? param + '=' + newval : '');
	if (window.location.href.includes('#')) {
		return window.location.href
			.replace(window.location.search, '')
			.replace('#', `${str}#`);
	}
	return `${window.location.href.split('?')[0]}${str}`;
};

export const getHotspotLink = (hotspotId) => {
	const param = 'linkHsId';
	return replaceParamValue(param, hotspotId);
};

export const generateRandomString = (length) => {
	const characters =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let result = '';
	const charactersLength = characters.length;
	for (let i = 0; i < length; i += 1) {
		result += characters.charAt(
			Math.floor(Math.random() * charactersLength),
		);
	}
	return result;
};

const selectFromVariantMap = (variantMap, resOrder, textureOrder) => {
	const selectedRes = resOrder.find((res) => variantMap[res]);
	if (selectedRes) {
		const selectedTexture = textureOrder.find(
			(texture) => variantMap[selectedRes][texture],
		);
		if (selectedTexture) {
			return variantMap[selectedRes][selectedTexture];
		}
	}
	return null;
};

const constructModelUrlFromModelMeta = (modelMeta) => {
	const variantMap = modelMeta?.variant_map || {};
	let finalVariant = isMobile
		? 'optimized_draco_webp_1k.glb'
		: 'optimized_draco_webp_4k.glb';

	const resSelectOrder = isMobileOnly ? ['1k'] : ['4k', '2k'];
	const textureSelectOrder = ['ktx2', 'webp'];

	const selectedVariant = selectFromVariantMap(
		variantMap,
		resSelectOrder,
		textureSelectOrder,
	);
	if (selectedVariant) {
		finalVariant = selectedVariant;
	}

	return (
		formURL(modelMeta?.model_dir) +
		finalVariant +
		'?key=' +
		modelMeta?.model_hash
	);
};

export const get3DModelUrl = (sceneData) => {
	if (sceneData?.scene_model && sceneData.scene_model.url) {
		if (
			sceneData.scene_model?.model_meta &&
			sceneData.scene_model?.model_meta?.model_dir
		) {
			return constructModelUrlFromModelMeta(
				sceneData.scene_model.model_meta,
			);
		}

		return formURL(sceneData.scene_model.url);
	}
};
